module.exports = __webpack_public_path__ + "static/media/form-old.ab7ea06e.svg";